import { render, staticRenderFns } from "./product-info-in-list.vue?vue&type=template&id=24625d11&scoped=true"
import script from "./product-info-in-list.vue?vue&type=script&lang=js"
export * from "./product-info-in-list.vue?vue&type=script&lang=js"
import style0 from "./product-info-in-list.vue?vue&type=style&index=0&id=24625d11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24625d11",
  null
  
)

export default component.exports